import { useTranslation } from '@nextgen-web-framework/all';
import { AmwayUserDetailsStatusEnum } from '@commerce-cart-webcomponents/sdk';
import styles from './DownlineUserCard.module.scss';
import DownlineUserCardTypes from './types/propTypes';

const DownlineUserCard = ({ profile, onDownlineUserSelect }: DownlineUserCardTypes) => {
  const t = useTranslation();
  const { accountId, firstName, lastName, status } = profile;

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label="downline user card click"
      className={`${styles['card-wrapper']} ${
        status === AmwayUserDetailsStatusEnum.Inactive ? styles['disabled'] : ''
      }`}
      onClick={() => onDownlineUserSelect(profile)}
      onKeyDown={() => onDownlineUserSelect(profile)}
      data-testid="downline-card-container-testid"
    >
      <div className={styles['user-name']} data-testid="downline-user-name-testid">{`${firstName} ${lastName}`}</div>
      <div data-testid="downline-user-account-testid">
        <span>{t('Subscription.checkout.account.id.label')}: </span>
        <span className={styles['account-number']}>{accountId}</span>
      </div>
    </div>
  );
};

export default DownlineUserCard;
